import React from 'react';
import './CreditDashboard.css';
import PageShell from '../components/layout/PageShell';
import CreditRiskIndicators from '../components/credit/CreditRiskIndicators';
import CreditGauge from '../components/credit/CreditGauge';
import CreditMap from '../components/credit/CreditMap';


const CreditDashboard: React.FC = () => {
  return (
    <PageShell>
      <div className="dashboardcontainer">
        <div className="dashboardwrapper">
          <CreditRiskIndicators />
        </div>
        <div className="dashboardwrapper">
          <CreditGauge />
        </div>
        <div className="dashboardwrapper">
          <CreditMap />
        </div>
      </div>
    </PageShell>
  );
};

export default CreditDashboard;
